import React, { createElement } from 'react';
import ReactDOM from 'react-dom';
import { render, unmountComponentAtNode } from 'react-dom';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure, RangeInput } from 'react-instantsearch-hooks-web';
// import RefinementSelector from './RefinementSelector';
import './SizeSelector.scss';
import SizeSelectorUI from './SizeSelectorUI';

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_ONLY_KEY);

const formatTitleforSearchQuery = (title) => {
  if (title.toLowerCase().includes('oz')) {
    return title.toLowerCase().split('oz')[1].trimStart();
  } else {
    return title.toLowerCase();
  }
};

const SizeSelectorComp = (props) => {
  const { type, style, size, lid, title } = props;

  let formattedTitle = formatTitleforSearchQuery(title);

  let configureQuery = (type) => {
    switch (type) {
      case 'Dog Bowls':
        return <Configure facetFilters={[`product_type: ${type}`]} hitsPerPage={100}></Configure>;

      case 'Grip Coffee Mug':
      case 'Grip Coffee Mug 2.0':
        return <Configure facetFilters={[`product_type: ${type}`]} hitsPerPage={100}></Configure>;

      // case 'Classic Tumbler':
      // case 'Classic Tumbler 2.0':
      // case 'Rover Tumbler':
      // case 'Rover Tumbler 2.0':
      //   return <Configure facetFilters={[`named_tags.Bottle Style: ${style}`, `product_type:${type}`]} hitsPerPage={100}></Configure>;

      default:
        return <Configure facetFilters={[`named_tags.Bottle Style: ${style}`, `product_type:${type}`]} hitsPerPage={100}></Configure>;
    }
  };

  return (
    <InstantSearch searchClient={searchClient} indexName="shopify_products">
      <Configure query={formattedTitle} restrictSearchableAttributes={'title'}></Configure>

      {configureQuery(type)}

      {/* {(type.includes('Tumbler') || type.includes('Coffee Mug')) && (
        <Configure facetFilters={[`collections: ${collectionFacetValues[type]}`]}></Configure>
      )} */}
      {/* <Configure facetFilters={[`named_tags.Lid Style: ${lid}`]}></Configure> */}
      {/* <RefinementSelector attribute="named_tags.Size" {...props} /> */}
      <SizeSelectorUI {...props}></SizeSelectorUI>
    </InstantSearch>
  );
};

if (!customElements.get('size-selector')) {
  customElements.define(
    'size-selector',
    class SizeSelector extends HTMLElement {
      connectedCallback() {
        const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
        const element = <SizeSelectorComp el={this} {...Object.fromEntries(props)}></SizeSelectorComp>;
        ReactDOM.render(element, this);
      }
      disconnectedCallback() {
        unmountComponentAtNode(SizeSelectorComp);
      }
    }
  );
}
